import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-dialog-confirmation-consent',
  templateUrl: './dialog-confirmation-consent.component.html',
  styleUrls: ['./dialog-confirmation-consent.component.css']
})
export class DialogConfirmationConsentComponent implements OnInit {
  platform: any
  currentlang: any
  notConsentList: any = ''
  @Input() notConsentChoosen: any;
  @Output() btnAction: EventEmitter<any> = new EventEmitter();

  constructor(
    public activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {
    this.platform = localStorage.getItem('platform');
    this.currentlang = localStorage.getItem('language');

    setTimeout(() => {
      let and = this.currentlang === 'id' ? ' dan ' : ' and ';

      if (this.notConsentChoosen.length === 1) {
        this.notConsentList = this.notConsentChoosen[0]['displayGroupName_' + this.currentlang];
      } else if (this.notConsentChoosen.length === 2) {
        this.notConsentList = this.notConsentChoosen[0]['displayGroupName_' + this.currentlang] + and + this.notConsentChoosen[1]['displayGroupName_' + this.currentlang];
      } else {
        for (var i = 0; i < this.notConsentChoosen.length; i++) {
          if (i < this.notConsentChoosen.length - 1) {
            this.notConsentList = this.notConsentList + this.notConsentChoosen[i]['displayGroupName_' + this.currentlang] + ", "
          } else {
            this.notConsentList = this.notConsentList + and + this.notConsentChoosen[i]['displayGroupName_' + this.currentlang]
          }
        }
      }
    }, 100);
  }

  close() {
    this.activeModal.close();
  }

  save(value: number) {
    this.close();
    this.btnAction.emit(value);
  }
}
